/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { EvaluationErrorDetails, VariableNotFoundErrorDetails, NumberCoercionErrorDetails } from './index'
 */

export class EvaluationError extends Error {
  /**
   * @param {string} message
   * @param {EvaluationErrorDetails} [details]
   * @param {ErrorOptions} [options]
   */
  constructor(message, details = {}, options = {}) {
    super(message, options);
    this.name = 'EvaluationError';
    this.node = details.node;
  }
}

export class VariableNotFoundError extends EvaluationError {
  /**
   * @param {VariableNotFoundErrorDetails} details
   * @param {ErrorOptions} [options]
   */
  constructor(details, options = {}) {
    super(
      `Variable ${JSON.stringify(details.name)} not found`,
      details,
      options
    );
    this.name = 'VariableNotFoundError';
    this.variableName = details.name;
  }
}

export class NumberCoercionError extends EvaluationError {
  /**
   * @param {NumberCoercionErrorDetails} details
   * @param {ErrorOptions} [options]
   */
  constructor(details, options = {}) {
    super(
      `Value '${details.value}' cannot be coerced to a finite number`,
      details,
      options
    );
    this.name = 'NumberCoercionError';
    this.value = details.value;
  }
}

export class UnknownNodeError extends EvaluationError {
  /**
   * @param {string} originalType
   * @param {ErrorOptions} [options]
   */
  constructor(originalType, options = {}) {
    super(`Unknown node type: ${originalType}`, {}, options);
    this.name = 'UnknownNodeError';
    this.originalType = originalType;
  }
}

/**
 * Agregovaná chyba — vyhozena z AND/OR při propagaci více chyb.
 */
export class AggregateEvaluationError extends EvaluationError {
  /**
   * @param {EvaluationError[]} errors
   */
  constructor(errors) {
    super(
      `Multiple evaluation errors (${errors.length})`,
      {},
      { cause: new AggregateError(errors, 'Multiple evaluation errors') }
    );
    this.name = 'AggregateEvaluationError';
    this.errors = errors;
  }
}
